export enum ReviewStatus {
  DRAFT = "draft",
  IN_REVIEW = "inReview",
  DISAPPROVED = "disapproved",
  APPROVED = "approved",
  REVIEW = "review",
}

export const StatusMapping = {
  Approved: ReviewStatus.APPROVED,
  "Pending Review": ReviewStatus.REVIEW,
  Disapproved: ReviewStatus.DISAPPROVED,
};

export enum ItemType {
  CustomJs = "customJs",
  App = "app",
}
